import type { BATCH_ACTIONS } from 'pages/Batch/configs';
import type { IPresetStep } from './types';
import { serializeStepParams, type ISerializeContext } from './paramSerializer';

type Listener = () => void;

class PresetSessionRecorder {
  private steps: IPresetStep[] = [];

  private listeners: Set<Listener> = new Set();

  recordStep(action: BATCH_ACTIONS, rawAttrs: Record<string, any>, context: ISerializeContext): void {
    const params = serializeStepParams(action, rawAttrs, context);
    if (params === null) return;

    this.steps.push({
      action,
      params,
    });
    this.notify();
  }

  getSteps(): IPresetStep[] {
    return [...this.steps];
  }

  clearSteps(): void {
    this.steps = [];
    this.notify();
  }

  subscribe(cb: Listener): () => void {
    this.listeners.add(cb);
    return () => {
      this.listeners.delete(cb);
    };
  }

  getSnapshot(): IPresetStep[] {
    return this.steps;
  }

  private notify(): void {
    this.listeners.forEach(cb => cb());
  }
}

export const presetSessionRecorder = new PresetSessionRecorder();
